import React from "react"
import {Box, CircularProgress, Container, Typography} from "@mui/material";
import {ErrorRounded} from "@mui/icons-material";

export default function Error() {

    return (
        <Container maxWidth={"md"} sx={{textAlign: "center", minHeight: "100vh"}}>
            <Box sx={{
                mt: 15,
                mb: 2,
            }}>
                <ErrorRounded color={"error"} sx={{ fontSize: 40 }} />
            </Box>
            <Typography align={"center"}>
                Erreur lors du chargement de l'application...
            </Typography>
        </Container>
    )
}